import {
    firstProductAttribute,
    isNonEmpty,
    PRODUCT_ATTRIBUTE_TYPE_VALUES,
    productAttributes,
} from './product-attributes'

const ProductReviewCheckStatus = Object.freeze({
    PASSED: 'passed',
    NEEDS_REVIEW: 'needs_review',
})

const defaultProductChecker = ({
    product,
    link,
    duplicateProductId = false,
    missingProduct = false,
}) => {
    const attributes = productAttributes(product)
    const validAttributes = attributes.length > 0 && attributes.every(attribute => (
        attribute
        && PRODUCT_ATTRIBUTE_TYPE_VALUES.includes(attribute.type)
        && isNonEmpty(attribute.value)
    ))

    return {
        checks: [
            {
                id: 'product-attributes',
                status: validAttributes
                    ? ProductReviewCheckStatus.PASSED
                    : ProductReviewCheckStatus.NEEDS_REVIEW,
                reason: {
                    messageKey: 'Component(ResearchReviewProcess):reason-confirm-product-attributes',
                    fallbackMessage: 'Confirm that every product attribute has a supported type and value.',
                },
            },
            {
                id: 'chemity-link',
                status: link && link.productId && link.status === 'accepted'
                    ? ProductReviewCheckStatus.PASSED
                    : ProductReviewCheckStatus.NEEDS_REVIEW,
                reason: {
                    messageKey: 'Component(ResearchReviewProcess):reason-link-chemity-product',
                    fallbackMessage: 'Select the matching Chemity product.',
                },
            },
            {
                id: 'unique-product-link',
                status: duplicateProductId
                    ? ProductReviewCheckStatus.NEEDS_REVIEW
                    : ProductReviewCheckStatus.PASSED,
                reason: {
                    messageKey: 'Component(ResearchReviewProcess):reason-product-link-duplicate',
                    fallbackMessage: 'This Chemity product is linked more than once.',
                },
            },
            {
                id: 'product-available',
                status: missingProduct
                    ? ProductReviewCheckStatus.NEEDS_REVIEW
                    : ProductReviewCheckStatus.PASSED,
                reason: {
                    messageKey: 'Component(ResearchReviewProcess):reason-product-link-missing',
                    fallbackMessage: 'The linked Chemity product is no longer available.',
                },
            },
        ],
        facts: [
            { id: 'has-product-id', value: !!firstProductAttribute(product, 'product_id') },
            { id: 'has-scip-number', value: !!firstProductAttribute(product, 'scip_number') },
            { id: 'has-accepted-link', value: !!(link && link.productId && link.status === 'accepted') },
        ],
    }
}

const mergeEvaluation = (target, addition = {}) => ({
    checks: target.checks.concat(addition.checks || []),
    facts: target.facts.concat(addition.facts || []),
})

const createProductReviewCheckerRegistry = ({ checkers = [], addons = [] } = {}) => Object.freeze({
    evaluate(input) {
        let evaluation = defaultProductChecker(input)
        evaluation = checkers.concat(addons).reduce((result, checker) => (
            mergeEvaluation(result, checker(input))
        ), evaluation)

        return {
            ...evaluation,
            status: evaluation.checks.some(check => (
                check.status === ProductReviewCheckStatus.NEEDS_REVIEW
            ))
                ? ProductReviewCheckStatus.NEEDS_REVIEW
                : ProductReviewCheckStatus.PASSED,
        }
    },
})

const productReviewCheckerRegistry = createProductReviewCheckerRegistry()

export {
    ProductReviewCheckStatus,
    createProductReviewCheckerRegistry,
    productReviewCheckerRegistry,
}

export default productReviewCheckerRegistry
